import { render, staticRenderFns } from "./schedule-appointment.vue?vue&type=template&id=d8b10a10"
import script from "./schedule-appointment.vue?vue&type=script&lang=js"
export * from "./schedule-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports